define([
    "dojo/_base/declare",
    "csi/_base/underscore",
    "csi/table/MoveUpDown"
], function(declare,_,MoveUpDown) {

    return declare(MoveUpDown, {
        preProcess: function() {

            this.inherited(arguments);

            if (this.targetNode) {
                var urlTarget = this.widget.getRefNodeUrl(this.targetNode);

                var value = this.getParentAttributeValue();
                var nStart = _.indexOf(value, this.m_urlNode);
                var nEnd = _.indexOf(value, urlTarget) ;
                this.nDiff = nEnd - nStart;
            }
        }
    });
});
